export const disableScrolling = () => {
  const x = window.scrollX;
  const y = window.scrollY;
  // eslint-disable-next-line func-names
  window.onscroll = function () { window.scrollTo(x, y); };
};
  
export const enableScrolling = () => {
  window.onscroll = null;
};
